"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var Section_1 = require("./Section");
var PlanCard_1 = __importDefault(require("./PlanCard"));
var QuoteBlockStore_1 = __importDefault(require("QuoteV2/Stores/QuoteBlockStore"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var QuoteComponents_1 = require("./QuoteComponents");
var classnames_1 = __importDefault(require("classnames"));
var QuoteViewStore_1 = require("QuoteV2/Stores/QuoteViewStore");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var mobx_1 = require("mobx");
var PlanGroupTabs_1 = __importDefault(require("./PlanGroupTabs"));
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var DiscountPill_1 = __importDefault(require("./DiscountPill"));
var QuoteItemStore_1 = require("QuoteV2/Stores/QuoteItemStore");
var lodash_1 = require("lodash");
var es_toolkit_1 = require("es-toolkit");
var QuoteSectionStore_1 = require("QuoteV2/Stores/QuoteSectionStore");
var c = (0, BemBuilder_1.default)("plan-section");
var PlanSection = (function (_super) {
    __extends(PlanSection, _super);
    function PlanSection(props) {
        var _this = _super.call(this, props) || this;
        _this.sectionRef = react_1.default.createRef();
        _this.selectSection = function () {
            var section = _this.props.section;
            _this.quoteViewStore.setSelectedSection(section.id);
            _this.onClickOutside.startListening();
        };
        _this.deselectSection = function () {
            var _a = _this.props;
            _this.onClickOutside.stopListening();
            _this.quoteViewStore.setSelectedSection(undefined);
        };
        _this.changeGroup = function (group) {
            var section = _this.props.section;
            if (section.hasGroup(group)) {
                _this._currentGroup = group;
            }
            else {
                _this._currentGroup = undefined;
            }
        };
        _this.getDiscountByGroup = function (group) {
            var section = _this.props.section;
            if (!section.groupByBillingSchedule) {
                return null;
            }
            var items = section.itemsByGroup(group);
            var firstItemWithDiscount = items.find(function (item) { return item instanceof QuoteItemStore_1.QuotePricedItemStore && item.discount.enabled; });
            if (firstItemWithDiscount && firstItemWithDiscount instanceof QuoteItemStore_1.QuotePricedItemStore) {
                if ((0, lodash_1.every)(items, function (item) {
                    return item instanceof QuoteItemStore_1.QuotePricedItemStore &&
                        item.discount.enabled &&
                        item.discount.units === firstItemWithDiscount.discount.units &&
                        item.discount.type === firstItemWithDiscount.discount.type;
                })) {
                    return firstItemWithDiscount.discount;
                }
            }
            return null;
        };
        _this.onClickOutside = new utils_1.OnClickOutside([
            ".".concat(c("", props.section.id)),
            ".quote-section-toolbar",
            ".quote-section-toolbar__style-popover",
            ".quote-section-toolbar-options__subpanel",
            ".context-menu-react__menu",
            ".context-menu-react__subpanel",
        ], _this.deselectSection);
        var selectedItems = _this.props.section.items.filter(function (item) { return item instanceof QuoteItemStore_1.QuotePricedItemStore && item.isOptional && item.isOptionalSelected; });
        var billingScheduleWithSelectedItem = _this.props.section.groups.find(function (schedule) { return !!selectedItems.find(function (item) { return (0, es_toolkit_1.isEqual)(item.billingSchedule, schedule); }); });
        if (billingScheduleWithSelectedItem) {
            _this._currentGroup = billingScheduleWithSelectedItem;
        }
        return _this;
    }
    Object.defineProperty(PlanSection.prototype, "currentGroup", {
        get: function () {
            var _a;
            return (_a = this._currentGroup) !== null && _a !== void 0 ? _a : this.props.section.groups[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanSection.prototype, "groups", {
        get: function () {
            return this.props.section.groups;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanSection.prototype, "productItems", {
        get: function () {
            return this.props.section.itemsByGroup(QuoteSectionStore_1.PRODUCT_TOKEN_GROUP);
        },
        enumerable: false,
        configurable: true
    });
    PlanSection.prototype.componentDidMount = function () {
        var _this = this;
        this.reactionDisposer = (0, mobx_1.reaction)(function () { return [_this.groups, _this.productItems]; }, function (_a) {
            var _b = __read(_a, 2), appliedSchedules = _b[0], productItems = _b[1];
            var section = _this.props.section;
            if (!section.hasGroup(_this.currentGroup)) {
                _this.changeGroup(section.groups[0]);
            }
            var productItemIds = productItems.map(function (item) { return item.id; });
            if (_this.lastProductItemIds && productItemIds.length > 0 && !(0, es_toolkit_1.isEqual)(productItemIds, _this.lastProductItemIds)) {
                _this.changeGroup(QuoteSectionStore_1.PRODUCT_TOKEN_GROUP);
            }
            _this.lastProductItemIds = productItemIds;
        });
    };
    PlanSection.prototype.componentWillUnmount = function () {
        var _a;
        this.onClickOutside.stopListening();
        (_a = this.reactionDisposer) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    Object.defineProperty(PlanSection.prototype, "isFourColumnLayout", {
        get: function () {
            return this.cards.length === 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanSection.prototype, "cards", {
        get: function () {
            var section = this.props.section;
            if (section.groupByBillingSchedule) {
                return section.itemsByGroup(this.currentGroup);
            }
            return section.items;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanSection.prototype, "allowIndividualDiscountPills", {
        get: function () {
            var section = this.props.section;
            var isGroupingEnabled = section.groupByBillingSchedule;
            var hasMoreThanOneGroup = section.groups.length > 1;
            var currentGroupHasDiscounts = this.getDiscountByGroup(this.currentGroup) !== null;
            return !(isGroupingEnabled && hasMoreThanOneGroup && currentGroupHasDiscounts);
        },
        enumerable: false,
        configurable: true
    });
    PlanSection.prototype.render = function () {
        var _a, _b;
        var _this = this;
        var section = this.props.section;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c(), c("", section.id), "project-block__widget-element"), ref: this.sectionRef },
            this.quoteComponents.SectionToolbar && (react_1.default.createElement(this.quoteComponents.SectionToolbar, { section: section, sectionRef: this.sectionRef, additionalItems: this.quoteComponents.PlanSectionOptionsMenu && (react_1.default.createElement(this.quoteComponents.PlanSectionOptionsMenu, { section: section })) })),
            this.quoteViewStore.isSelectionEnabled && (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("selector"), (_a = {},
                    _a["".concat(c("selector", "selected"))] = this.quoteViewStore.selectedSectionId === section.id,
                    _a)), onClick: this.selectSection })),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(c("title")), onFocus: this.deselectSection, onClick: function (ev) {
                    ev.stopPropagation();
                } },
                (this.quote.showSectionLabels || section.discount.enabled) && (react_1.default.createElement("div", { className: c("details") },
                    this.quote.showSectionLabels && (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("label"), "user-font") },
                        this.quoteViewStore.getLabel(Types_1.QuoteLabel.Section),
                        " ",
                        this.quote.getSectionLabel(section))),
                    section.discount.enabled && react_1.default.createElement(DiscountPill_1.default, { discount: section.discount, className: c("discount") }))),
                react_1.default.createElement(this.quoteComponents.SectionDescription, { content: section.description })),
            section.groupByBillingSchedule && (react_1.default.createElement(PlanGroupTabs_1.default, { section: section, selectedGroup: this.currentGroup, onChangeGroup: this.changeGroup, getGroupDiscount: this.getDiscountByGroup })),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(c("cards"), (_b = {},
                    _b[c("cards", "three-column")] = !this.isFourColumnLayout,
                    _b[c("cards", "four-column")] = this.isFourColumnLayout,
                    _b)) }, this.cards.map(function (card) { return (react_1.default.createElement(PlanCard_1.default, { item: card, section: section, key: card.id, onChangeBillingSchedule: function (schedule) { return _this.changeGroup(schedule); }, allowDiscountPill: _this.allowIndividualDiscountPills })); }))));
    };
    var _a, _b, _c, _d, _e, _f;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_b = typeof QuoteBlockStore_1.default !== "undefined" && QuoteBlockStore_1.default) === "function" ? _b : Object)
    ], PlanSection.prototype, "quote", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteViewStore_1.QuoteViewStore.$),
        __metadata("design:type", typeof (_c = typeof QuoteViewStore_1.QuoteViewStore !== "undefined" && QuoteViewStore_1.QuoteViewStore) === "function" ? _c : Object)
    ], PlanSection.prototype, "quoteViewStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteComponents_1.QuoteComponents.$),
        __metadata("design:type", typeof (_d = typeof QuoteComponents_1.QuoteComponents !== "undefined" && QuoteComponents_1.QuoteComponents) === "function" ? _d : Object)
    ], PlanSection.prototype, "quoteComponents", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], PlanSection.prototype, "_currentGroup", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_f = typeof QuoteSectionStore_1.Group !== "undefined" && QuoteSectionStore_1.Group) === "function" ? _f : Object),
        __metadata("design:paramtypes", [])
    ], PlanSection.prototype, "currentGroup", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], PlanSection.prototype, "groups", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], PlanSection.prototype, "productItems", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], PlanSection.prototype, "isFourColumnLayout", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], PlanSection.prototype, "cards", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], PlanSection.prototype, "changeGroup", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], PlanSection.prototype, "allowIndividualDiscountPills", null);
    PlanSection = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [typeof (_a = typeof Section_1.SectionProps !== "undefined" && Section_1.SectionProps) === "function" ? _a : Object])
    ], PlanSection);
    return PlanSection;
}(react_1.default.Component));
exports.default = PlanSection;
